import { SHARED_PROJECT } from '@shared/constants';

type ResolveReportFooterOrganizationNameOptions = {
  /** Auth0 display name for the organization the user is in. */
  displayName?: string;
  /** Selected organization slug, including the public-route sentinel. */
  selectedOrganization?: string;
  /** First organization slug stored on the project. */
  projectOrganization?: string;
  /**
   * Display name from the `organizationName` query param. Used when the
   * session has no Auth0 profile, including print, shared, and generation links.
   */
  printOrganizationName?: string;
};

/**
 * Organization label for the report footer.
 * Skips {@link SHARED_PROJECT} so print and shared routes show the real
 * organization instead of "shared".
 */
export const resolveReportFooterOrganizationName = (
  options: ResolveReportFooterOrganizationNameOptions,
): string | undefined => {
  const displayName = options.displayName?.trim();
  if (displayName) return displayName;

  const selected = options.selectedOrganization?.trim();
  if (selected && selected !== SHARED_PROJECT) return selected;

  const printed = options.printOrganizationName?.trim();
  if (printed) return printed;

  const projectOrganization = options.projectOrganization?.trim();
  return projectOrganization || undefined;
};

/**
 * Version name shown in every report footer.
 * Proposal pages keep the proposal name in the title, not here.
 */
export const getReportFooterContextName = (
  versionName: string | undefined,
): string | undefined => {
  const trimmed = versionName?.trim();
  return trimmed || undefined;
};
